import * as yup from 'yup';

export const customerSchema = yup.object({
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().required('Last name is required'),
  mobile_number: yup.number().positive().integer().required('Mobile number is required'),
  email: yup.string().email('Please enter a valid email').required('Email is required'),
});